import { Button, Card, DatePicker, Dialog, Message } from '@alifd/next';
import { Box } from '@mui/material';
import {
  Cascader,
  Checkbox,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  Table,
  Tag,
} from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import BarcodeReader from 'react-barcode-reader';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import useSWR from 'swr';

import EditCategories from '@/components/UI/desktop/EditCategories';
import LoadingSpin from '@/components/UI/LoadingSpin';
import useService from '@/lib/hooks/useService';
import { generateHouseHoldNumberCascader } from '@/utils/generateHouseHoldNumberCascader';
import { getResidentsByHouseholdNumber } from '@/utils/getResidentsByHouseholdNumber';

import client from '../../../../lib/feathers';
import Barcode from './barcode';
import styles from './index.module.scss';

const { Option } = Select;
const { Item } = Form;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const PostalRegistrationList = () => {
  const [addPostalForm] = Form.useForm();
  const [editPostalForm] = Form.useForm();

  const user = useSelector((state) => state.user);
  const [allowedFuncs, setAllowedFuncs] = useState([]);
  useEffect(() => {
    if (user.userGroup.key) {
      setAllowedFuncs(user.userGroup.key.checkedKeys);
    }
  }, [user]);

  const categoryMenu = client.service('categoryMenu');
  const postalRegistrationService = client.service('postalRegistration');

  const [addDialog, setAddDialog] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [previewDialog, setPreviewDialog] = useState(false);
  const [packagerRegistrationTime, setPackagerRegistrationTime] = useState('');
  const [barcodeDisplay, setBarcodeDisplay] = useState('');
  const [barcodeDisplayNew, setBarcodeDisplayNew] = useState('');
  const [barcodeDialog, setBarcodeDialog] = useState(false);
  const [editBarcodeDialog, setEditBarcodeDialog] = useState(false);
  const [tarUserId, setTarUserId] = useState(''); // 包裹戶號user.name
  const [tarUserObjectId, setTarUserObjectId] = useState(''); // 包裹戶號user._id
  const [postalDetail, setPostalDetail] = useState(null);
  const [loading, setLoading] = useState(false);

  // 廠商
  const [vendorCategoryDataArr, setVendorCategoryDataArr] = useState([]);
  // 物流
  const [logisticsCategoryDataArr, setLogisticsCategoryDataArr] = useState([]);
  // 擺放位置
  const [placementCategoryDataArr, setPlacementCategoryDataArr] = useState([]);

  // 包裹類型
  const [postalTypeDataArr, setPostalTypeDataArr] = useState([]);
  const [filterObj, setFilterObj] = useState({});
  const [householdInfo, setHouseholdInfo] = useState('');

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [users] = useService({
    collectionName: 'users',
    query: {
      householdNumbers: { $exists: true },
      f_password: { $exists: false },
    },
  });
  const [communityData] = useService({
    collectionName: 'communityData',
  });

  const getPostalServiceQuery = () => {
    const postalServiceQuery = {
      $sort: {
        createdTime: -1,
      },
      $limit: pageSize,
      $skip: (page - 1) * pageSize,
      status: { $nin: ['已退貨', '退貨中'] },
    };

    if (filterObj.household) {
      postalServiceQuery.household = filterObj.household.join('-');
    }

    if (filterObj.packageType) {
      postalServiceQuery.packageType = filterObj.packageType;
    }

    if (
      filterObj.createdTime &&
      filterObj.createdTime.$gte &&
      filterObj.createdTime.$lte
    ) {
      postalServiceQuery.createdTime = {
        $gte: filterObj.createdTime.$gte,
        $lte: filterObj.createdTime.$lte,
      };
    }

    return postalServiceQuery;
  };

  const getPostalRegistrations = async () => {
    const postalServiceQuery = getPostalServiceQuery();
    const { data, total } = await client.service('postalRegistration').find({
      query: postalServiceQuery,
    });

    return { postalRegistrations: data, total };
  };

  const {
    data: postalListResponse,
    mutate: updatePostalRegistration,
    isLoading,
  } = useSWR(getPostalServiceQuery(), getPostalRegistrations);

  const [residentAccountNumbers] = useService({
    collectionName: 'residentAccountNumbers',
  });

  const sortVendor = (a, b) => {
    const aVendor = a['vendor'];
    const bVendor = b['vendor'];
    return aVendor?.localeCompare(bVendor);
  };

  const sortNaN = (a, b, dataIndex) => {
    const aText = Array.isArray(a[dataIndex])
      ? a[dataIndex].reduce((text, value) => {
          return text + value;
        }, '')
      : a[dataIndex];
    const bText = Array.isArray(b[dataIndex])
      ? b[dataIndex].reduce((text, value) => {
          return text + value;
        }, '')
      : b[dataIndex];

    return aText.localeCompare(bText);
  };

  const columnSorter = useCallback((a, b, dataIndex) => {
    if (typeof a[dataIndex] === 'number') {
      return a[dataIndex] - b[dataIndex];
    } else {
      return sortNaN(a, b, dataIndex);
    }
  }, []);

  const config = {
    background: '#f5f5f5',
    marginTop: '20px',
    marginBottom: '20px',
    width: 1,
    display:
      (barcodeDialog && barcodeDisplayNew === '') ||
      (barcodeDialog && barcodeDisplay === '')
        ? 'none'
        : 'block',
  };

  const handleCategoryUpdate = () => {
    serverCategoryDataUpdate();
  };

  // categoryMenu
  const findCategory = useCallback(async () => {
    try {
      const result = await categoryMenu.find({
        query: { service: 'postalRegistration' },
      });

      return result && result.data ? result.data : [];
    } catch (error) {
      console.error(error);
    }
  }, [categoryMenu]);

  const serverCategoryDataUpdate = useCallback(async () => {
    try {
      const res = await findCategory();
      console.log('==categoryMenu find success:', res);
      setVendorCategoryDataArr(res[0].data);
      setLogisticsCategoryDataArr(res[1].data);
      setPlacementCategoryDataArr(res[2].data);
      setPostalTypeDataArr(res[3].data);
    } catch (error) {
      console.log('==categoryMenu find fail:', error);
    }
  }, [findCategory]);

  useEffect(() => {
    serverCategoryDataUpdate();
  }, [serverCategoryDataUpdate]);

  const addNewPostal = async (addNewPostalFormValues) => {
    setLoading(true);
    const {
      packageType,
      recipient,
      vendor,
      logistics,
      placement,
      robotDelivery,
    } = addNewPostalFormValues;
    console.log(robotDelivery, '===robotDelivery');

    const household = addNewPostalFormValues.household.join('-');

    try {
      const res = await postalRegistrationService.create({
        ...addNewPostalFormValues,
        createdTime: new Date().getTime(),
        updatedTime: new Date().getTime(),
        packagerRegistrationTime: new Date().getTime(),
        household,
        order: postalListResponse?.postalRegistrations.length,
        barcode: barcodeDisplay,
        packageType: packageType || '',
        recipient: recipient || '',
        vendor: vendor || '',
        logistics: logistics || '',
        placement: placement || '',
        status: '未領取',
        userId: tarUserId,
        userObjectId: tarUserObjectId,
        receiveTime: '待領取',
        residentPhoto: null,
        canvas: null,
        robotDelivery: !robotDelivery,
      });
      message.success('成功新增包裹!');
      console.log('==postal create result:', res);
      addPostalForm.resetFields();
      updatePostalRegistration();
      if (barcodeDisplayNew !== '') {
        setBarcodeDisplayNew('');
      }
      setBarcodeDisplay('');
      setTarUserId('');
      setAddDialog(false);
      setBarcodeDialog(false);
      setHouseholdInfo('');
      setLoading(false);
    } catch (error) {
      addPostalForm.resetFields();
      console.error(error);
      message.error('新增包裹失敗!');
      setLoading(false);
    }

    if (tarUserObjectId === '') {
      // 20220318 新增寄物通知推播
      try {
        const res = await axios('/ezcon/api/emitMsgQuery', {
          method: 'POST',
          headers: {
            authorization: window.localStorage['feathers-jwt'],
          },
          data: {
            service: 'message',
            event: 'msg',
            title: '郵件包裹通知',
            content: `${household}您有新的${packageType}請快來領取:${moment().format(
              'YYYY/MM/DD HH:mm'
            )}`,
            type: 'success',
            class: 'postalRegistration',
            duration: 8000,
            redirect: '/ezpro/postal/postalFrontDesk',
            query: {
              householdNumbers: {
                $in: [household],
              },
              firebaseClass: '郵件包裹',
            },
          },
        });
        console.log('==send message Success:', res);
        message.success('已傳送推播給住戶');
      } catch (error) {
        console.error('==send message fail:', error);
        message.error('傳送推播失敗!');
      }
    } else {
      try {
        const res = await axios('/ezcon/api/emitMsgQuery', {
          method: 'POST',
          headers: {
            authorization: window.localStorage['feathers-jwt'],
          },
          data: {
            service: 'message',
            event: 'msg',
            title: '郵件包裹通知',
            content: `${recipient}您有新的${packageType}請快來領取:${moment().format(
              'YYYY/MM/DD HH:mm'
            )}`,
            type: 'success',
            class: 'postalRegistration',
            duration: 8000,
            redirect: '/ezpro/postal/postalFrontDesk',
            query: {
              _id: tarUserObjectId,
              firebaseClass: '郵件包裹',
            },
          },
        });
        console.log('==send message Success:', res);
        message.success('已傳送推播給住戶');
      } catch (error) {
        console.error('==send message fail:', error);
        message.error('傳送推播失敗!');
      }
    }
  };

  const closeAddPostalModal = () => {
    addPostalForm.resetFields();
    setBarcodeDisplay('');
    setTarUserId('');
    setTarUserObjectId('');
    setAddDialog(false);
    setBarcodeDialog(false);
    setHouseholdInfo('');
  };

  const postalCascaderOptions = useMemo(() => {
    const householdNumbers = residentAccountNumbers.map(
      (resident) => resident.householdNumber
    );
    return generateHouseHoldNumberCascader(householdNumbers);
  }, [residentAccountNumbers]);

  const handleHouseholdChange = (value, form) => {
    form.setFieldValue('recipient', null);
    const houseItem = residentAccountNumbers.filter(
      (item) => item.householdNumber === value
    )[0];
    setHouseholdInfo(houseItem);
  };

  const handleFormValuesChange = (changedValues, form) => {
    if ('household' in changedValues) {
      handleHouseholdChange(changedValues['household']?.join('-'), form);
      setTarUserId('');
      setTarUserObjectId('');
    }
    if ('recipient' in changedValues && changedValues['recipient']) {
      const tarUserObject = users.find(
        (user) => user.name === changedValues['recipient']
      );
      setTarUserId(changedValues['recipient']);
      setTarUserObjectId(tarUserObject?._id);
    }
    if ('packageType' in changedValues) {
      changedValues['packageType'] === '大型包裹'
        ? form.setFieldValue('robotDelivery', true)
        : form.setFieldValue('robotDelivery', false);
    }
  };

  const handleEditPostalCancel = () => {
    editPostalForm.resetFields();
    setEditDialog(false);
    setBarcodeDisplayNew('');
  };

  const handleClickEditButton = useCallback(
    (record) => {
      const { recipient, vendor, logistics, robotDelivery, ...restValues } =
        record;
      editPostalForm.setFieldsValue({
        recipient: recipient === '' ? null : recipient,
        vendor: vendor === '' ? null : vendor,
        logistics: logistics === '' ? null : logistics,
        robotDelivery: !robotDelivery,
        ...restValues,
      });
      setTarUserId(record.userId || '');
      setTarUserObjectId(record.userObjectId || '');
      setBarcodeDisplay(record.barcode);
      setEditDialog(true);
    },
    [editPostalForm]
  );

  const handleEditFormSubmit = async () => {
    const allFormValues = editPostalForm.getFieldsValue(true);
    const data = {
      ...allFormValues,
      household: Array.isArray(editPostalForm.getFieldValue('household'))
        ? editPostalForm.getFieldValue('household').join('-')
        : editPostalForm.getFieldValue('household'),
      recipient: editPostalForm.getFieldValue('recipient') ?? '',
      vendor: editPostalForm.getFieldValue('vendor') ?? '',
      logistics: editPostalForm.getFieldValue('logistics') ?? '',
      barcode: barcodeDisplayNew,
      userId: tarUserId ? tarUserId : '',
      userObjectId: tarUserObjectId ? tarUserObjectId : '',
    };

    try {
      await postalRegistrationService.patch(data._id, data);
      editPostalForm.resetFields();
      setTarUserObjectId('');
      setBarcodeDisplay('');
      setBarcodeDisplayNew('');
      updatePostalRegistration();
      setEditDialog(false);
      message.success('資料更新成功!');
    } catch (error) {
      console.error(error);
      message.error('資料更新失敗!');
    }
  };

  const handleCheckDetailClick = (record) => {
    setPostalDetail(record);
    setPackagerRegistrationTime(record.packagerRegistrationTime);
    setBarcodeDisplay(record.barcode);
    setTarUserObjectId(record.userObjectId || '');
    setPreviewDialog(true);
  };

  const closeCheckDetailModal = () => {
    setPostalDetail(null);
    setPreviewDialog(false);
  };

  const addPostalFormInitValues = {
    packageType: null,
    household: [],
    recipient: null,
    placement: null,
    vendor: null,
    logistics: null,
    robotDelivery: false,
    remarks: '',
  };

  const deletePostal = useCallback(
    async (recordId) => {
      try {
        const result = await Swal.fire({
          title: '確定刪除此包裹資料?',
          text: '刪除後將無法復原!!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#BEBEBE',
          confirmButtonText: '確定',
          cancelButtonText: '取消',
        });

        if (result.isConfirmed) {
          try {
            await postalRegistrationService.remove(recordId);
            updatePostalRegistration();
            message.success('資料刪除成功!');
          } catch (error) {
            console.error(error);
            message.error('資料刪除失敗!');
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    [postalRegistrationService, updatePostalRegistration]
  );

  const tableColumns = useMemo(() => {
    return [
      {
        title: '編號',
        dataIndex: 'plateNumber',
        fixed: 'left',
        sorter: (a, b) => columnSorter(a, b, 'plateNumber'),
        width: 100,
      },
      {
        title: '包裹類型',
        dataIndex: 'packageType',
        sorter: (a, b) => columnSorter(a, b, 'packageType'),
        render: (value, record) => {
          if (record.status === '未領取') {
            return (
              <>
                <div>{value}</div>{' '}
                <div>
                  <Tag color="red">未領取</Tag>
                </div>
              </>
            );
          } else {
            return (
              <>
                <div>{value}</div>{' '}
                <div>
                  <Tag color="green">已領取</Tag>
                </div>
              </>
            );
          }
        },
      },
      {
        title: '戶號',
        dataIndex: 'household',
        sorter: (a, b) => columnSorter(a, b, 'household'),
        render: (value) => {
          const houseItem = residentAccountNumbers.filter(
            (item) => item.householdNumber === value
          )[0];
          if (houseItem?.members?.length > 0) {
            return (
              <div>
                <div>{value} </div>
                <div>
                  <Tag color="green">已開通</Tag>
                </div>
              </div>
            );
          } else {
            return (
              <div>
                <div>{value}</div>
                <div>
                  <Tag color="red">未開通</Tag>
                </div>
              </div>
            );
          }
        },
      },
      {
        title: '收件人',
        dataIndex: 'recipient',
        sorter: (a, b) => columnSorter(a, b, 'recipient'),
      },
      {
        title: '廠商',
        dataIndex: 'vendor',
        sorter: (a, b) => sortVendor(a, b),
      },
      {
        title: '擺放位置',
        dataIndex: 'placement',
        sorter: (a, b) => columnSorter(a, b, 'placement'),
      },
      {
        title: '建立時間',
        dataIndex: 'createdTime',
        sorter: (a, b) => columnSorter(a, b, 'createdTime'),
        render: (_value, record) => {
          return (
            <p>{moment(record.createdTime).format('YYYY-MM-DD HH:mm:ss')}</p>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'actions',
        fixed: 'right',
        render: (_value, record, index) => {
          return (
            <>
              <div className={styles.btn}>
                <Button
                  type="secondary"
                  onClick={() => handleCheckDetailClick(record)}
                >
                  查看
                </Button>
                <Button
                  type="normal"
                  onClick={() => handleClickEditButton(record, index)}
                >
                  編輯
                </Button>

                <Button
                  type="primary"
                  warning
                  onClick={() => deletePostal(record._id)}
                >
                  刪除
                </Button>
              </div>
            </>
          );
        },
      },
    ];
  }, [
    columnSorter,
    deletePostal,
    handleClickEditButton,
    residentAccountNumbers,
  ]);

  const tableDataSource = useMemo(() => {
    let dataSource = postalListResponse?.postalRegistrations;

    if ('packageType' in filterObj) {
      dataSource = dataSource?.filter(
        (postal) => postal.packageType === filterObj.packageType
      );
    }

    if ('household' in filterObj) {
      dataSource = dataSource?.filter(
        (postal) => postal.household === filterObj.household.join('-')
      );
    }
    if ('createdTime' in filterObj) {
      const {
        createdTime: { $gte, $lte },
      } = filterObj;

      const dateFilterIncludesNaN = isNaN($gte) || isNaN($lte);
      dataSource = dateFilterIncludesNaN
        ? dataSource
        : dataSource?.filter((postal) =>
            moment(postal.createdTime).isBetween($gte, $lte)
          );
    }

    return dataSource;
  }, [postalListResponse?.postalRegistrations, filterObj]);

  if (isLoading) {
    return <LoadingSpin />;
  }

  const getDateFilterValue = () => {
    if (filterObj.createdTime) {
      const { $gte, $lte } = filterObj.createdTime;

      const dateFilterValue = [
        isNaN($gte) ? null : moment($gte),
        isNaN($lte) ? null : moment($lte),
      ];
      return dateFilterValue;
    } else {
      return undefined;
    }
  };
  console.log(
    getResidentsByHouseholdNumber(
      addPostalForm.getFieldValue('household')?.join('-'),
      users
    ),
    '===test'
  );
  return (
    <>
      {/* 掃描條碼 */}
      <Dialog
        hasMask
        className={styles.barcodeDialog}
        visible={barcodeDialog}
        footer={false}
        onClose={() => {
          setBarcodeDialog(false);
        }}
      >
        <Form>
          <BarcodeReader
            onScan={(data) => {
              const regex = /^[\d|a-zA-Z]+$/;
              if (regex.test(data)) {
                setBarcodeDisplay(data);
                Message.success('掃描成功');
                setAddDialog(true);
              } else {
                Message.error('掃描失敗，僅能數字和英文');
                setAddDialog(false);
              }
            }}
            onError={(err) => {
              console.error(err);
            }}
          />
          <Item>
            <Input
              style={{ width: '300px' }}
              placeholder="自行輸入條碼 Enter確認"
              name="barcodeDisplay"
              value={barcodeDisplay}
              onChange={(event) => {
                setBarcodeDisplay(event.target.value);
              }}
              onPressEnter={() => {
                const regex = /^[\d|a-zA-Z]+$/;
                if (regex.test(barcodeDisplay)) {
                  Message.success('掃描成功');
                  setBarcodeDialog(false);
                  setAddDialog(true);
                } else {
                  Message.error('掃描失敗，僅能數字和英文');
                  setBarcodeDialog(false);
                  setBarcodeDisplay('');
                }
              }}
            />
          </Item>
          <br />
          <img
            className={styles.packageImg}
            src="https://i.ibb.co/q05FPsK/Lovepik-com-401547424-express-2.png"
            alt="package"
            type="cover"
            width={400}
            height={300}
          />

          <h1>請掃描包裹/郵件條碼...</h1>
        </Form>
      </Dialog>

      {/* 新增包裹 */}
      <Modal
        className={styles.dialog}
        open={addDialog}
        footer={null}
        onCancel={closeAddPostalModal}
      >
        {loading ? (
          <LoadingSpin />
        ) : (
          <Form
            layout="vertical"
            form={addPostalForm}
            initialValues={addPostalFormInitValues}
            onFinish={addNewPostal}
            onValuesChange={(changedValues) =>
              handleFormValuesChange(changedValues, addPostalForm)
            }
          >
            {/* <p>顯示條碼:{barcodeDisplay}</p> */}
            <div className={styles.categoryBox}>
              <Item
                label="包裹類型"
                name="packageType"
                rules={[
                  {
                    required: true,
                    message: '請選擇包裹類型',
                  },
                ]}
              >
                <Select style={{ width: 200 }} placeholder="請選擇類型">
                  {postalTypeDataArr.map((item) => {
                    return <Option key={item}>{item}</Option>;
                  })}
                </Select>
              </Item>

              {/* <Item label="資訊" className={styles.categoryItem}>
              <Select
                style={{ width: 200 }}
                defaultValue="請選擇方式"
                onChange={(value) => {
                  setCategoryChildSelect({ value, disabled });
                }}
                disabled={disabled}
              >
                {data
                  ? data.map((item) => {
                      return <Option key={item}>{item}</Option>;
                    })
                  : ''}
              </Select>
            </Item> */}
            </div>
            <div className={styles.categoryBox}>
              <Item label="戶號" required>
                <Item
                  name="household"
                  rules={[
                    {
                      required: true,
                      message: '請選擇戶號',
                    },
                  ]}
                >
                  <Cascader
                    style={{ width: 200 }}
                    placeholder="請選擇戶號"
                    options={postalCascaderOptions}
                    displayRender={(label) => label.join('-')}
                    allowClear={false}
                  />
                </Item>
                <div style={{ marginTop: 10 }}>
                  {householdInfo !== '' &&
                    (householdInfo?.members?.length > 0 ? (
                      <Tag color="green">已開通</Tag>
                    ) : (
                      <div>
                        <div>
                          <Tag color="red">未開通</Tag>
                        </div>
                      </div>
                    ))}
                </div>
              </Item>
              {communityData[0]?.showPackageRecipient && (
                <Item
                  label="收件人(只會有該帳號可以看到資料)"
                  name="recipient"
                  className={styles.categoryItem}
                >
                  <Select
                    allowClear
                    style={{ width: 200 }}
                    placeholder="請選擇收件人"
                    value={addPostalForm.getFieldValue('recipient')}
                    options={getResidentsByHouseholdNumber(
                      addPostalForm.getFieldValue('household')?.join('-'),
                      users
                    )}
                  />
                </Item>
              )}
            </div>
            <Item
              label="擺放位置"
              name="placement"
              rules={[
                {
                  required: true,
                  message: '請選擇擺放位置',
                },
              ]}
            >
              <Select
                style={{ width: 200 }}
                placeholder="請選擇擺放位置"
                showSearch
                allowClear
              >
                {placementCategoryDataArr.map((item) => {
                  return <Option key={item}>{item}</Option>;
                })}
              </Select>
            </Item>
            <div className={styles.categoryBox}>
              <Item label="廠商" name="vendor">
                <Select
                  style={{ width: 200 }}
                  placeholder="請選擇廠商"
                  showSearch
                  allowClear
                >
                  {vendorCategoryDataArr.map((item) => {
                    return <Option key={item}>{item}</Option>;
                  })}
                </Select>
              </Item>
              <Item
                label="物流"
                name="logistics"
                className={styles.categoryItem}
              >
                <Select
                  style={{ width: 200 }}
                  placeholder="請選擇物流"
                  showSearch
                  allowClear
                >
                  {logisticsCategoryDataArr.map((item) => {
                    return <Option key={item}>{item}</Option>;
                  })}
                </Select>
              </Item>
            </div>
            {allowedFuncs.includes('送件服務') && (
              <Item name="robotDelivery" valuePropName="checked">
                <Checkbox>此為大型包裹(無法由機器人派送)</Checkbox>
              </Item>
            )}
            <div className={styles.categoryBox}>
              <Item label="備註" name="remarks">
                <TextArea
                  maxLength={30}
                  placeholder="可用30字元"
                  rows={2}
                  showCount
                  aria-label="input max length 30"
                />
              </Item>
            </div>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '10px',
                  alignItems: 'center',
                }}
              >
                <Input
                  // label="Enter value here"
                  value={barcodeDisplay}
                  // onChange={e => setBarcodeValue(e.target.value)}
                  margin="normal"
                  style={{ width: '50%' }}
                  placeholder="請按掃描條碼"
                  disabled
                />
                <Button onClick={() => setBarcodeDialog(true)}>掃描條碼</Button>
              </Box>
              {barcodeDisplay ? (
                <Barcode
                  value={barcodeDisplay}
                  {...config}
                  onResult={(result) => {
                    if (!result) {
                      Message.error('禁止中文輸入，請切換英文輸入');
                      setAddDialog(false);
                      setBarcodeDisplay('');
                      setBarcodeDialog(true);
                    }
                  }}
                />
              ) : (
                <div className={styles.barcodeDisplayPlaceholder} />
              )}
            </Box>
            {/* <div>
            <BarcodeReader

              onScan={(data) => {
                setBarcodeDisplay(data)
                console.log(data)
              }}
              onError={(err) => {
                console.error(err)
              }}
            />
            <p>顯示條碼:{barcodeDisplay}</p>
          </div> */}
            <Item>
              <Space className={styles.postalFormButtonsContainer}>
                <Button onClick={closeAddPostalModal}>取消</Button>
                <Button type="primary" htmlType="submit">
                  確定
                </Button>
              </Space>
            </Item>
          </Form>
        )}
      </Modal>

      {/* 編輯包裹 */}
      <Modal
        className={styles.dialog}
        open={editDialog}
        footer={null}
        onCancel={handleEditPostalCancel}
      >
        <Form
          form={editPostalForm}
          layout="vertical"
          onFinish={handleEditFormSubmit}
          onValuesChange={(changedValues) =>
            handleFormValuesChange(changedValues, editPostalForm)
          }
        >
          <div className={styles.categoryBox}>
            <Item
              label="包裹類型"
              name="packageType"
              rules={[
                {
                  required: true,
                  message: '請選擇包裹類型',
                },
              ]}
            >
              <Select style={{ width: 200 }} placeholder="請選擇類型">
                {postalTypeDataArr.map((item) => {
                  return <Option key={item}>{item}</Option>;
                })}
              </Select>
            </Item>
          </div>
          <div className={styles.categoryBox}>
            <Item label="戶號" required>
              <Item
                name="household"
                rules={[
                  {
                    required: true,
                    message: '請選擇戶號',
                  },
                ]}
              >
                <Cascader
                  style={{ width: 200 }}
                  placeholder="請選擇戶號"
                  options={postalCascaderOptions}
                  displayRender={(label) => label.join('-')}
                  allowClear={false}
                />
              </Item>
              <div style={{ marginTop: 10 }}>
                {householdInfo !== '' &&
                  (householdInfo?.members?.length > 0 ? (
                    <Tag color="green">已開通</Tag>
                  ) : (
                    <div>
                      <div>
                        <Tag color="red">未開通</Tag>
                      </div>
                    </div>
                  ))}
              </div>
            </Item>
            {communityData[0]?.showPackageRecipient && (
              <Item
                label="收件人(只會有該帳號可以看到資料)"
                name="recipient"
                className={styles.categoryItem}
              >
                <Select
                  allowClear
                  style={{ width: 200 }}
                  placeholder="請選擇收件人"
                  value={editPostalForm.getFieldValue('recipient')}
                  options={getResidentsByHouseholdNumber(
                    editPostalForm.getFieldValue('household'),
                    users
                  )}
                />
              </Item>
            )}
          </div>
          <Item
            label="擺放位置"
            name="placement"
            rules={[
              {
                required: true,
                message: '請選擇擺放位置',
              },
            ]}
          >
            <Select
              style={{ width: 200 }}
              placeholder="請選擇擺放位置"
              showSearch
              allowClear
            >
              {placementCategoryDataArr.map((item) => {
                return <Option key={item}>{item}</Option>;
              })}
            </Select>
          </Item>
          <div className={styles.categoryBox}>
            <Item label="廠商" name="vendor">
              <Select
                style={{ width: 200 }}
                placeholder="請選擇廠商"
                showSearch
                allowClear
              >
                {vendorCategoryDataArr.map((item) => {
                  return <Option key={item}>{item}</Option>;
                })}
              </Select>
            </Item>
            <Item label="物流" name="logistics" className={styles.categoryItem}>
              <Select
                style={{ width: 200 }}
                placeholder="請選擇物流"
                showSearch
                allowClear
              >
                {logisticsCategoryDataArr.map((item) => {
                  return <Option key={item}>{item}</Option>;
                })}
              </Select>
            </Item>
          </div>
          {allowedFuncs.includes('送件服務') && (
            <Item name="robotDelivery" valuePropName="checked">
              <Checkbox>此為大型包裹(無法由機器人派送)</Checkbox>
              {/* <Radio.Group
              onChange={(e) => {
                setRobotDelivery(e.target.value);
              }}
              value={robotDelivery}
            >
              <Radio value={true}>是</Radio>
              <Radio value={false}>否</Radio>
            </Radio.Group> */}
            </Item>
          )}
          <div className={styles.categoryBox}>
            <Item label="備註" name="remarks">
              <TextArea
                maxLength={30}
                placeholder="可用30字元"
                rows={2}
                showCount
                aria-label="input max length 30"
              />
            </Item>
          </div>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            <Input
              label="原有條碼"
              disabled
              value={barcodeDisplay}
              style={{
                width: '50%',
              }}
            />
            <div>
              <Button
                onClick={() => {
                  setEditBarcodeDialog(true);
                }}
              >
                更改條碼
              </Button>
              <Dialog
                hasMask
                className={styles.barcodeDialog}
                visible={editBarcodeDialog}
                footer={false}
                onClose={() => {
                  setEditBarcodeDialog(false);
                  setBarcodeDisplayNew('');
                }}
              >
                <div>
                  <BarcodeReader
                    onScan={(data) => {
                      setBarcodeDisplayNew(data);
                      console.log(data);
                      // setEditDialog(true)
                      setEditBarcodeDialog(false);
                    }}
                    onError={(err) => {
                      console.error(err);
                    }}
                  />
                  <Input
                    placeholder="自行輸入新條碼 Enter確認"
                    // value={barcodeDisplay}
                    onChange={(event) => {
                      setBarcodeDisplayNew(event.target.value);
                    }}
                    onPressEnter={() => {
                      setEditBarcodeDialog(false);
                    }}
                  />
                  {/* <p>顯示條碼:{barcodeDisplayText}</p> */}
                  <br />
                  <img
                    className={styles.packageImg}
                    src="https://i.ibb.co/q05FPsK/Lovepik-com-401547424-express-2.png"
                    alt="package"
                    type="cover"
                    width={400}
                    height={300}
                  />

                  <h1>請掃描包裹/郵件條碼...</h1>
                </div>
              </Dialog>
            </div>
            {barcodeDisplay !== '' && (
              <>
                <Barcode value={barcodeDisplay} {...config} />
                <br />
                <br />
              </>
            )}

            <p>更改後條碼:{barcodeDisplayNew}</p>
            {barcodeDisplayNew && (
              <Barcode
                value={barcodeDisplayNew}
                {...config}
                onResult={(result) => {
                  if (!result) {
                    Message.error('禁止中文輸入，請切換英文輸入');
                    setEditBarcodeDialog(true);
                  }
                }}
              />
            )}
          </Box>
          <Item>
            <Space className={styles.postalFormButtonsContainer}>
              <Button onClick={handleEditPostalCancel}>取消</Button>
              <Button type="primary" htmlType="submit">
                確定
              </Button>
            </Space>
          </Item>
        </Form>
      </Modal>

      {/* 查看包裹  */}
      <Modal
        className={styles.dialog}
        open={previewDialog}
        onCancel={closeCheckDetailModal}
        footer={
          <Button type="primary" onClick={closeCheckDetailModal}>
            關閉
          </Button>
        }
      >
        <Space direction="vertical">
          <div>
            <h5 className={styles.detailTitle}>包裹登記時間</h5>
            <h3>{new Date(packagerRegistrationTime).toLocaleString()}</h3>
          </div>

          <div>
            <h5 className={styles.detailTitle}>包裹類型</h5>
            <h3>{postalDetail?.packageType}</h3>
          </div>

          <div>
            <h5 className={styles.detailTitle}>戶號</h5>
            <h3>{postalDetail?.household}</h3>
          </div>

          <div>
            <h5 className={styles.detailTitle}>收件人</h5>
            <h3>
              {postalDetail?.recipient === ''
                ? '無資料'
                : postalDetail?.recipient}
            </h3>
          </div>

          <div>
            <h5 className={styles.detailTitle}>擺放位置</h5>
            <h3>{postalDetail?.placement}</h3>
          </div>

          <div>
            <h5 className={styles.detailTitle}>廠商</h5>
            <h3>
              {postalDetail?.vendor === '' ? '無資料' : postalDetail?.vendor}
            </h3>
          </div>

          <div>
            <h5 className={styles.detailTitle}>物流</h5>
            <h3>
              {postalDetail?.logistics === ''
                ? '無資料'
                : postalDetail?.logistics}
            </h3>
          </div>

          {allowedFuncs.includes('送件服務') && (
            <div>
              <h5 className={styles.detailTitle}>是否機器人派送</h5>
              <h3>{postalDetail?.robotDelivery === true ? '是' : '否'}</h3>
            </div>
          )}

          <div>
            <h5 className={styles.detailTitle}>備註</h5>
            <h3>
              {postalDetail?.remarks === '' ? '無資料' : postalDetail?.remarks}
            </h3>
          </div>

          <div>
            <h5 className={styles.detailTitle}>條碼</h5>
            <h3>
              {barcodeDisplay === '' ? (
                '無資料'
              ) : (
                <Barcode value={barcodeDisplay} {...config} />
              )}
            </h3>
          </div>
        </Space>
      </Modal>

      <div className={styles.container}>
        <div className={styles.btnBox}>
          <Button
            className={styles.typeBtn1}
            onClick={() => {
              setBarcodeDisplay('');
              setAddDialog(true);
            }}
          >
            新增包裹
          </Button>
          <EditCategories
            categoryName="寄件類別"
            buttonLabel="編輯包裹類型"
            dialogTitle="編輯包裹類型"
            onUpdate={handleCategoryUpdate}
          />
          <EditCategories
            categoryName="廠商"
            buttonLabel="編輯廠商"
            dialogTitle="編輯廠商"
            onUpdate={handleCategoryUpdate}
          />
          <EditCategories
            categoryName="物流"
            buttonLabel="編輯物流"
            dialogTitle="編輯物流"
            onUpdate={handleCategoryUpdate}
          />
          <EditCategories
            categoryName="擺放位置"
            buttonLabel="編輯位置"
            dialogTitle="編輯位置"
            onUpdate={handleCategoryUpdate}
          />
        </div>
        <div className={styles.btnBox}>
          <div>
            類型：
            <Select
              allowClear
              style={{ width: 200 }}
              placeholder="請選擇類型"
              value={filterObj.packageType}
              onChange={async (value) => {
                let newFilter = { ...filterObj };
                if (value) {
                  newFilter = {
                    ...newFilter,
                    packageType: value,
                  };
                } else {
                  delete newFilter.packageType;
                }
                setPage(1);
                setFilterObj(newFilter);
              }}
            >
              {postalTypeDataArr.map((item) => {
                return <Option key={item}>{item}</Option>;
              })}
            </Select>
          </div>
          <div style={{ marginLeft: 10 }}>
            戶號：
            <Cascader
              placeholder="請選擇戶號"
              className={styles.cascader}
              options={postalCascaderOptions}
              value={filterObj.household}
              onChange={async (value) => {
                let newFilter = { ...filterObj };
                if (value) {
                  newFilter = {
                    ...newFilter,
                    household: value,
                  };
                } else {
                  delete newFilter.household;
                }
                setPage(1);
                setFilterObj(newFilter);
              }}
            />
          </div>
          <div style={{ marginLeft: 10 }}>
            時間：
            <RangePicker
              value={getDateFilterValue()}
              onChange={async (value) => {
                let newFilter = { ...filterObj };
                if (value.length === 2) {
                  newFilter = {
                    ...newFilter,
                    createdTime: {
                      $gte: moment(value[0]).startOf('day').valueOf(),
                      $lte: moment(value[1]).endOf('day').valueOf(),
                    },
                  };
                } else {
                  delete newFilter.createdTime;
                }
                setPage(1);
                setFilterObj(newFilter);
              }}
            />
          </div>
        </div>
        {/* <ReactDragListView onDragEnd={onDragEnd}> */}
        <Card free>
          <Card.Content>
            <Table
              dataSource={tableDataSource}
              columns={tableColumns}
              scroll={{ x: 'max-content' }}
              rowKey="_id"
              pagination={{
                current: page,
                pageSize,
                total: postalListResponse ? postalListResponse.total : 0,
                onChange: (page, pageSize) => {
                  setPage((prevPage) => (prevPage === page ? prevPage : page));
                  setPageSize((prevPageSize) =>
                    prevPageSize === pageSize ? prevPageSize : pageSize
                  );
                },
              }}
            >
              {/* <Table.Column title="物流" dataIndex="logistics" width={200} /> */}
              {/* <Table.Column title="備註" dataIndex="remarks" width={150} /> */}
            </Table>
            {/* </ReactDragListView> */}
          </Card.Content>
        </Card>
      </div>
    </>
  );
};

export default PostalRegistrationList;
